import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { Password } from 'src/app/interfaces/password';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';

@Component({
  selector: 'app-password-profile',
  templateUrl: './password-profile.component.html',
  styleUrls: ['./password-profile.component.scss']
})
export class PasswordProfileComponent implements OnInit, OnChanges {

  @Input() authProvider: string | null = null;

  formPassword: FormGroup;
  usuario: JwtResponse;
  editarContra: boolean;
  mensajeExito: string;
  mensajeError: string;
  mostrarMensaje:boolean;
  esOAuth: boolean = false;
  oauthProviderLabel: string = '';
  showNuevaPass: boolean = false;
  showConfirmPass: boolean = false;

  constructor(private formBuilder: FormBuilder, private usuarioService: UsuarioService) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.editarContra = false;
    this.mostrarMensaje = false;
    this.recalcOAuth();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['authProvider']) this.recalcOAuth();
  }

  private recalcOAuth(): void {
    const provider = (this.authProvider || (this.usuario as any)?.user?.authProvider || '').toLowerCase();
    this.esOAuth = provider === 'google' || provider === 'linkedin';
    this.oauthProviderLabel = provider === 'google' ? 'Google'
                            : provider === 'linkedin' ? 'LinkedIn'
                            : '';
  }

  ngOnInit() {
    this.formPassword = this.formBuilder.group({
      passNueva: [null, Validators.required],
      passConfim: [null, Validators.required]
    });
  }

  actualizarContrasenia(){
    this.mostrarMensaje = true;
    if(this.formPassword.valid){
      const password: Password = {
        idUsuario: this.usuario.user.idUsuario,
        nuevaPass: this.formPassword.get('passNueva').value,
        confirmPass: this.formPassword.get('passConfim').value,
        rol: this.usuario.role
      };
      this.mostrarMensaje = false;
      this.usuarioService.actualizarContrasenia(password)
      .pipe(catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.mensajeError = mensajeError;
        setTimeout(() => {
          this.mensajeError = "" as string;
        }, 3000);
        return throwError(mensajeError);
      }))
      .subscribe(result => {
        if (result.success) {
          this.ngOnInit();
          this.mensajeExito = 'Éxito se ha actualizado su contraseña.';
          setTimeout(() => {
            this.mensajeExito = "" as string;
          }, 3000);
        } else {
          this.mensajeError = result.messageError;
          console.error('Error al actualizar la contraseña', result.messageError);
        }
      });
    }
    setTimeout(() => {
        this.mostrarMensaje = false;
      }, 3000);
  }

  cambiarContra(){
    this.editarContra = !this.editarContra;
  }

}
